import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ParameterType } from 'src/app/interfaces/parameter';
import { ParametersService } from 'src/app/services/parameters.service';
@Component({
	selector: 'app-settings-params',
	templateUrl: './settings-params.component.html',
	styleUrls: ['./settings-params.component.scss']
})
export class SettingsParamsComponent implements OnInit {
	public parameters: Array<ParameterType> = []
	public params: Array<string> = [
		"PRIORITY",
		"SPEECH_LOCAL_ROOM",
		"TOTEM_CALENDAR",
		"SPEECH_PREV_PANEL",
		"SPEECH_NAME_PANEL",
		"TOTEM_DIMENSAO",
		"TOTEM_HISTORY",
		"TOTEM_USEPANELS",
		"TOTEM_PRINTER",
		"TOTEM_SKIP_PATIENT_DATA",
		"USAR_LOCAL"
	]
	public formSettings: FormGroup
	public showSpinner: boolean = false
	public parametersResponse: Array<ParameterType> = []
	constructor(
		private parameterService: ParametersService,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute
	) {
		this.formSettings = this.formBuilder.group({})
		this.createForm()
		this.parametersResponse = this.route.snapshot.data['params']
		this.parameterService.getVarSys("USAR_LOCAL").subscribe(
			(varSys) => {
				let aux = varSys[0]
				aux.chave = aux.param
				aux.valor = aux.value
				this.parametersResponse.push(aux)
			}
		)
	}
	ngOnInit(): void {
		setTimeout(() => {
			this.parametersResponse.forEach((item: ParameterType) => {
				this.formSettings.controls[item.chave!].setValue(item.valor)
			});
		}, 1000);
	}

	createForm() {
		this.params.forEach(element => {
			this.formSettings.addControl(element, new FormControl())
		});
	}

	submitForm() {
		this.showSpinner = true
		this.parameterService.updateParams(this.formSettings.value)
		setTimeout(() => {
			this.showSpinner = false
			window.location.reload()
		}, 2000);
	}

	testPrint() {
		fetch(`http://localhost:8080/imprimir/teste`)
	}
}
